const CONFIG = {
	// 本地及测试环境
	development: {
		baseUrl: 'https://niuyifei.com/',
		appid: 'wx1dea0bd3ed567022'
	},
	test: {
		baseUrl: 'https://niuyifei.com/',
		appid: 'wx1dea0bd3ed567022'
	},
	// 生产环境
	production: {
		baseUrl: 'https://api.aniudata.com/',
		appid: 'wx9ef223c01e6f418a'
	}
};

const ENV = process.env.NODE_ENV || 'development';
export default CONFIG[ENV] || CONFIG.development;
